const VideoChatConnectionStatus = {
  pending: 'pending',
  connecting: 'connecting',
  connected: 'connected',
  connectionError: 'connectionError',
};

export default VideoChatConnectionStatus;
